var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "14px",
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-3",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "HomeMap",
    transform: "translate(-33.000000, -25.000000)",
    fill: "#30287b",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Topbar"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Search",
    transform: "translate(24.000000, 16.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-27"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.903618,21.8208584 L19.5842488,18.5014892 C19.5213613,18.4386016 19.439334,18.4057907 19.3518383,18.4057907 L18.9909184,18.4057907 C19.8522045,17.4077926 20.3744446,16.1090279 20.3744446,14.6872223 C20.3744446,11.5455788 17.8288658,9 14.6872223,9 C11.5455788,9 9,11.5455788 9,14.6872223 C9,17.8288658 11.5455788,20.3744446 14.6872223,20.3744446 C16.1090279,20.3744446 17.4077926,19.8522045 18.4057907,18.9909184 L18.4057907,19.3518383 C18.4057907,19.439334 18.4413359,19.5213613 18.5014892,19.5842488 L21.8208584,22.903618 C21.9493677,23.0321273 22.1571701,23.0321273 22.2856794,22.903618 L22.903618,22.2856794 C23.0321273,22.1571701 23.0321273,21.9493677 22.903618,21.8208584 Z M14.6872223,19.0620087 C12.2701528,19.0620087 10.3124359,17.1042918 10.3124359,14.6872223 C10.3124359,12.2701528 12.2701528,10.3124359 14.6872223,10.3124359 C17.1042918,10.3124359 19.0620087,12.2701528 19.0620087,14.6872223 C19.0620087,17.1042918 17.1042918,19.0620087 14.6872223,19.0620087 Z",
    id: "search"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.14f8bf319eb6479340c6184d968c033d.svg";
export { ForwardRef as ReactComponent };